import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	UnlikePetitionSupporterVideo,
	type UnlikePetitionSupporterVideoMutation,
	type UnlikePetitionSupporterVideoMutationVariables,
} from './index.graphql';

export async function unlikePetitionSupporterVideo({
	videoId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	videoId: string;
	utilityContext: UtilityContext;
}): Promise<UnlikePetitionSupporterVideoMutation | null | undefined> {
	const { data: unlikeResult } = await fetch<
		UnlikePetitionSupporterVideoMutation,
		UnlikePetitionSupporterVideoMutationVariables
	>({
		query: UnlikePetitionSupporterVideo,
		variables: { videoId },
		rejectOnError: true,
	});
	return unlikeResult;
}
